"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("../../components");
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
require("./AuthModal.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var AuthModal = function AuthModal(_ref) {
  var onClose = _ref.onClose,
    modalVisible = _ref.modalVisible,
    description = _ref.description,
    action = _ref.action,
    className = _ref.className;
  var location = (0, _reactRouterDom.useLocation)();
  var redirectTo = (0, _react.useMemo)(function () {
    return "".concat(location.pathname, "?action=").concat(JSON.stringify(action));
  }, [location, action]);
  return /*#__PURE__*/_react.default.createElement(_components.Modal, {
    className: (0, _classnames.default)('auth-modal ant-modal-natural-height', className),
    centered: true,
    visible: modalVisible,
    footer: null,
    onClose: onClose,
    destroyOnClose: true,
    onCancel: onClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium text-center text-black px-[20px] pt-[48px] md:px-[0px] md:tw-subtitle-lg-medium"
  }, "Join Monument!"), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-light text-center text-black px-[20px] pt-[20px] pb-[50px] md:px-[0px] md:tw-body-lg-light"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row justify-center pt-[24px] pb-[5px] mx-[-20px] border-0 border-solid border-t border-grey-25 md:pt-[32px] md:pb-[12px]"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "w-[130px] h-[46px] mr-[40px] md:mr-[48px] md:w-[176px] label-small-medium",
    url: "/sign-in?redirectTo=".concat(redirectTo)
  }, "Log In"), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: {
      pathname: '/signup',
      state: {
        redirectTo: redirectTo
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    className: "w-[130px] h-[46px] md:w-[176px] label-small-medium"
  }, "Sign up"))));
};
AuthModal.propTypes = {
  onClose: _propTypes.default.func,
  modalVisible: _propTypes.default.bool,
  description: _propTypes.default.string,
  action: _propTypes.default.object,
  className: _propTypes.default.string
};
var _default = AuthModal;
exports.default = _default;